export class CreateRemoveAndRefitRequest {
  quoteId: string;
  customerId: number;
  currentPlot: string;
  destinationPlot: string;
  comments: string;
  originalPlanSquareFootage: number;
}
